class ClickAndCollect {
  constructor(settings) {
    this.settings = settings;
    this.element = document.getElementById("cnc-container");
    this.resultsContainer = document.getElementById("cnc-results-container");
    this.mapContainer = document.getElementById("cnc-map-container");
    this.messages = {};
    this.mapFocus = null;
    if (this.settings.enableMap && window.mapIsReady) {
      this.mapReady();
    }
  }
  addMessage(name, value, isError) {
    if (!this.messages[name]) {
      var message = new Message(value, isError);
      this.messages[name] = message;
      this.resultsContainer.appendChild(message.getElement());
    }
  }
  removeMessage(name) {
    if (this.messages[name]) {
      this.messages[name].getElement().outerHTML = "";
      delete this.messages[name];
    }
  }
  clearErrors() {
    for (let [name, message] of Object.entries(this.messages)) {
      if (message.isError) {
        this.removeMessage(name);
      }
    }
  }
  addAddressSearch() {
    this.search = new AddressSearch(this);
    this.mapContainer.appendChild(this.search.getElement());
  }
  addMap() {
    this.gmap = new GMap(this);
    this.mapContainer.appendChild(this.gmap.getElement());
    this.gmap.initMap();
  }
  mapReady() {
    this.addAddressSearch();
    this.addMap();
  }
  sentenceCase(str) {
    if (str === null || str === "") return false;
    else str = str.toString();

    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  searchAddress(address) {
    var mainCitiesWithCode = [];
    mainCitiesWithCode["Sydney"] = [
      "2023",
      "2026",
      "2027",
      "2031",
      "2033",
      "2035",
      "2036",
      "2037",
      "2039",
      "2041",
      "2043",
      "2044",
      "2047",
      "2130",
      "2131",
      "2132",
      "2133",
      "2134",
      "2135",
      "2136",
      "2142",
      "2143",
      "2144",
      "2160",
      "2161",
      "2162",
      "2163",
      "2164",
      "2165",
      "2166",
      "2167",
      "2168",
      "2169",
      "2170",
      "2171",
      "2176",
      "2177",
      "2178",
      "2179",
      "2190",
      "2191",
      "2192",
      "2193",
      "2194",
      "2195",
      "2196",
      "2197",
      "2198",
      "2199",
      "2203",
      "2204",
      "2205",
      "2206",
      "2207",
      "2208",
      "2209",
      "2211",
      "2212",
      "2213",
      "2214",
      "2216",
      "2217",
      "2218",
      "2219",
      "2220",
      "2221",
      "2223",
      "2224",
      "2225",
      "2226",
      "2227",
      "2228",
      "2230",
      "2231",
      "2232",
      "2233",
      "2234",
      "2500",
      "2502",
      "2505",
      "2506",
      "2508",
      "2515",
      "2516",
      "2517",
      "2518",
      "2525",
      "2526",
      "2527",
      "2528",
      "2529",
      "2530",
      "2564",
      "2565",
      "2572",
      "2575",
      "2745",
      "2752",
      "2759",
      "2478",
      "2479",
      "2481",
      "2482",
      "2483",
      "2484",
      "2485",
      "2486",
      "2487",
      "2488",
      "2489",
      "2490",
      "2061",
      "2063",
      "2064",
      "2065",
      "2066",
      "2068",
      "2069",
      "2071",
      "2072",
      "2073",
      "2075",
      "2076",
      "2077",
      "2078",
      "2079",
      "2080",
      "2082",
      "2083",
      "2084",
      "2085",
      "2086",
      "2087",
      "2088",
      "2089",
      "2090",
      "2092",
      "2093",
      "2094",
      "2095",
      "2096",
      "2097",
      "2099",
      "2101",
      "2102",
      "2103",
      "2104",
      "2105",
      "2106",
      "2107",
      "2108",
      "2109",
      "2110",
      "2111",
      "2113",
      "2114",
      "2115",
      "2116",
      "2117",
      "2118",
      "2119",
      "2120",
      "2122",
      "2123",
      "2124",
      "2125",
      "2126",
      "2127",
      "2128",
      "2129",
      "2137",
      "2138",
      "2140",
      "2145",
      "2146",
      "2147",
      "2148",
      "2150",
      "2151",
      "2152",
      "2153",
      "2154",
      "2155",
      "2156",
      "2157",
      "2158",
      "2159",
      "2250",
      "2251",
      "2256",
      "2257",
      "2258",
      "2260",
      "2262",
      "2263",
      "2750",
      "2753",
      "2754",
      "2756",
      "2758",
      "2760",
      "2761",
      "2763",
      "2768",
      "2780",
      "2782",
      "2000",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2024",
      "2025",
      "2028",
      "2029",
      "2030",
      "2032",
      "2034",
      "2038",
      "2040",
      "2042",
      "2045",
      "2046",
      "2048",
      "2049",
      "2050",
      "2055",
      "2060",
      "2062",
      "2067",
      "2070",
      "2100",
      "2200",
      "2112",
      "2121",
      "2222",
      "2326",
    ];
    mainCitiesWithCode["Adelaide"] = ["5000"];
    mainCitiesWithCode["Melbourne"] = [
      "3002",
      "3003",
      "3004",
      "3005",
      "3006",
      "3008",
      "3011",
      "3012",
      "3013",
      "3015",
      "3016",
      "3018",
      "3019",
      "3020",
      "3021",
      "3022",
      "3023",
      "3024",
      "3025",
      "3026",
      "3027",
      "3028",
      "3029",
      "3030",
      "3031",
      "3032",
      "3034",
      "3037",
      "3038",
      "3050",
      "3051",
      "3121",
      "3141",
      "3142",
      "3143",
      "3144",
      "3145",
      "3150",
      "3161",
      "3162",
      "3163",
      "3166",
      "3167",
      "3168",
      "3169",
      "3171",
      "3172",
      "3174",
      "3175",
      "3177",
      "3182",
      "3183",
      "3184",
      "3186",
      "3187",
      "3188",
      "3189",
      "3190",
      "3191",
      "3193",
      "3194",
      "3195",
      "3197",
      "3198",
      "3200",
      "3201",
      "3202",
      "3204",
      "3205",
      "3206",
      "3207",
      "3211",
      "3212",
      "3214",
      "3220",
      "3337",
      "3338",
      "3340",
      "3910",
      "3911",
      "3912",
      "3913",
      "3915",
      "3918",
      "3919",
      "3928",
      "3930",
      "3931",
      "3933",
      "3934",
      "3937",
      "3938",
      "3939",
      "3940",
      "3941",
      "3943",
      "3978",
      "3980",
      "3010",
      "3033",
      "3036",
      "3039",
      "3040",
      "3041",
      "3042",
      "3043",
      "3044",
      "3045",
      "3046",
      "3047",
      "3048",
      "3049",
      "3052",
      "3054",
      "3055",
      "3056",
      "3057",
      "3058",
      "3059",
      "3060",
      "3061",
      "3062",
      "3063",
      "3064",
      "3065",
      "3066",
      "3067",
      "3068",
      "3070",
      "3071",
      "3072",
      "3073",
      "3074",
      "3075",
      "3076",
      "3078",
      "3079",
      "3081",
      "3083",
      "3085",
      "3086",
      "3087",
      "3088",
      "3089",
      "3090",
      "3091",
      "3093",
      "3094",
      "3095",
      "3096",
      "3097",
      "3099",
      "3102",
      "3105",
      "3107",
      "3111",
      "3113",
      "3114",
      "3115",
      "3116",
      "3122",
      "3126",
      "3127",
      "3128",
      "3129",
      "3130",
      "3131",
      "3132",
      "3134",
      "3135",
      "3136",
      "3138",
      "3139",
      "3140",
      "3147",
      "3149",
      "3152",
      "3155",
      "3158",
      "3159",
      "3160",
      "3164",
      "3178",
      "3180",
      "3427",
      "3428",
      "3429",
      "3750",
      "3751",
      "3752",
      "3755",
      "3757",
      "3759",
      "3760",
      "3761",
      "3763",
      "3770",
      "3788",
      "3789",
      "3800",
      "3808",
      "3810",
      "3812",
      "3000",
      "3001",
      "841",
      "894",
      "867",
      "813",
      "807",
      "847",
      "835",
      "800",
      "852",
      "885",
      "887",
      "810",
      "844",
      "823",
      "824",
      "826",
      "851",
      "865",
      "873",
      "860",
      "831",
      "833",
      "874",
      "804",
      "803",
      "854",
      "866",
      "802",
      "855",
      "821",
      "888",
      "889",
      "853",
      "876",
      "896",
      "898",
      "843",
      "891",
      "882",
      "837",
      "884",
      "877",
      "808",
      "864",
      "858",
      "842",
      "819",
      "827",
      "856",
      "862",
      "828",
      "848",
      "820",
      "890",
      "801",
      "838",
      "863",
      "868",
      "872",
      "829",
      "875",
      "892",
      "834",
      "849",
      "880",
      "818",
      "811",
      "832",
      "830",
      "846",
      "879",
      "825",
      "878",
      "822",
      "845",
      "815",
      "893",
      "869",
      "861",
      "840",
      "886",
      "836",
      "899",
      "812",
      "870",
      "897",
      "814",
      "817",
      "850",
      "881",
      "806",
      "839",
      "809",
      "871",
      "805",
      "857",
      "859",
      "816",
      "895",
      "883",
    ];
    mainCitiesWithCode["Mildura West"] = ["3500"];
    mainCitiesWithCode["Hattah"] = ["3501"];
    mainCitiesWithCode["Mildura"] = ["3502"];
    mainCitiesWithCode["Queensland"] = [
      "4205",
      "4207",
      "4208",
      "4209",
      "4210",
      "4211",
      "4214",
      "4215",
      "4216",
      "4219",
      "4221",
      "4222",
      "4224",
      "4225",
      "4228",
      "4229",
      "4230",
      "4270",
      "4271",
      "4275",
      "4280",
      "4287",
      "4000",
      "4001",
      "4002",
      "4003",
      "4004",
      "4005",
      "4007",
      "4008",
      "4009",
      "4010",
      "4011",
      "4012",
      "4013",
      "4014",
      "4017",
      "4018",
      "4025",
      "4029",
      "4030",
      "4032",
      "4033",
      "4051",
      "4053",
      "4054",
      "4055",
      "4060",
      "4064",
      "4065",
      "4066",
      "4069",
      "4070",
      "4078",
      "4102",
      "4103",
      "4104",
      "4105",
      "4106",
      "4107",
      "4108",
      "4109",
      "4110",
      "4111",
      "4112",
      "4113",
      "4114",
      "4115",
      "4116",
      "4117",
      "4118",
      "4119",
      "4120",
      "4121",
      "4123",
      "4124",
      "4125",
      "4127",
      "4128",
      "4129",
      "4130",
      "4131",
      "4132",
      "4133",
      "4151",
      "4152",
      "4153",
      "4154",
      "4155",
      "4156",
      "4157",
      "4159",
      "4160",
      "4161",
      "4163",
      "4164",
      "4165",
      "4169",
      "4170",
      "4171",
      "4172",
      "4173",
      "4174",
      "4178",
      "4183",
      "4184",
      "4301",
      "4303",
      "4304",
      "4305",
      "4306",
      "4307",
      "4311",
      "4312",
      "4340",
      "4341",
      "4342",
      "4343",
      "4346",
      "4500",
      "4501",
      "4502",
      "4503",
      "4505",
      "4020",
      "4021",
      "4022",
      "4506",
      "4507",
      "4508",
      "4510",
      "4511",
      "4512",
      "4514",
      "4515",
      "4517",
      "4518",
      "4519",
      "4520",
      "4521",
      "4550",
      "4551",
      "4552",
      "4553",
      "4554",
      "4555",
      "4556",
      "4557",
      "4558",
      "4559",
      "4560",
      "4564",
      "4575",
      "4655",
      "4650",
      "4601",
      "4600",
      "4581",
      "4580",
      "4574",
      "4573",
      "4571",
      "4570",
      "4569",
      "4568",
      "4567",
      "4566",
      "4565",
      "4563",
      "4562",
      "4561",
      "4513",
      "4400",
      "4401",
      "4402",
      "4403",
      "4408",
      "4410",
      "4411",
      "4412",
      "4413",
      "4415",
      "4416",
      "4417",
      "4418",
      "4419",
      "4420",
      "4421",
      "4422",
      "4423",
      "4424",
      "4425",
      "4426",
      "4427",
      "4428",
      "4454",
      "4455",
      "4461",
      "4462",
      "4465",
      "4467",
      "4468",
      "4470",
      "4471",
      "4472",
      "4474",
      "4475",
      "4477",
      "4478",
      "4479",
      "4509",
      "4516",
      "4572",
      "4605",
      "4606",
      "4608",
      "4610",
      "4611",
      "4612",
      "4613",
      "4614",
      "4615",
      "4620",
      "4621",
      "4625",
      "4626",
      "4627",
      "4630",
      "4659",
      "4660",
      "4662",
      "4670",
      "4671",
      "4673",
      "4674",
      "4676",
      "4677",
      "4678",
      "4680",
      "4694",
      "4695",
      "4697",
      "4699",
      "4700",
      "4701",
      "4702",
      "4703",
      "4704",
      "4705",
      "4706",
      "4707",
      "4709",
      "4710",
      "4712",
      "4713",
      "4714",
      "4715",
      "4716",
      "4717",
      "4718",
      "4719",
      "4720",
      "4721",
      "4722",
      "4723",
      "4724",
      "4725",
      "4726",
      "4727",
      "4728",
      "4730",
      "4731",
      "4732",
      "4733",
      "4735",
      "4736",
      "4737",
      "4738",
      "4739",
      "4740",
      "4741",
      "4742",
      "4743",
      "4744",
      "4745",
      "4746",
      "4750",
      "4751",
      "4753",
      "4754",
      "4756",
      "4757",
      "4798",
      "4799",
      "4800",
      "4801",
      "4802",
      "4803",
      "4804",
      "4805",
      "4806",
      "4807",
      "4808",
      "4809",
      "4810",
      "4811",
      "4812",
      "4814",
      "4815",
      "4816",
      "4817",
      "4818",
      "4819",
      "4820",
      "4821",
      "4822",
      "4823",
      "4824",
      "4825",
      "4828",
      "4829",
      "4830",
      "4849",
      "4850",
      "4852",
      "4854",
      "4855",
      "4856",
      "4857",
      "4858",
      "4859",
      "4860",
      "4861",
      "4865",
      "4868",
      "4869",
      "4870",
      "4871",
      "4872",
      "4873",
      "4874",
      "4875",
      "4876",
      "4878",
      "4879",
      "4880",
      "4882",
      "4883",
      "4885",
      "4886",
      "4890",
      "4891",
    ];
    mainCitiesWithCode["Maroochydore"] = [
      "4701",
      "4703",
      "4815",
      "4885",
      "4514",
      "4739",
      "4879",
      "4864",
      "4751",
      "4511",
      "4510",
      "4657",
      "4857",
      "4454",
      "4707",
      "4477",
      "4403",
      "4555",
      "4676",
      "4737",
      "4898",
      "4537",
      "4400",
      "4690",
      "4643",
      "4470",
      "4684",
      "4425",
      "4763",
      "4642",
      "4534",
      "4553",
      "4411",
      "4801",
      "4543",
      "4590",
      "4620",
      "4641",
      "4401",
      "4524",
      "4598",
      "4741",
      "4728",
      "4665",
      "4545",
      "4823",
      "4837",
      "4556",
      "4717",
      "4614",
      "4652",
      "4579",
      "4888",
      "4544",
      "4760",
      "4531",
      "4875",
      "4824",
      "4413",
      "4540",
      "4467",
      "4884",
      "4513",
      "4679",
      "4408",
      "4547",
      "4746",
      "4648",
      "4535",
      "4854",
      "4530",
      "4550",
      "4704",
      "4649",
      "4528",
      "4593",
      "4699",
      "4892",
      "4541",
      "4515",
      "4735",
      "4628",
      "4807",
      "4873",
      "4636",
      "4773",
      "4618",
      "4696",
      "4840",
      "4727",
      "4804",
      "4578",
      "4468",
      "4559",
      "4576",
      "4421",
      "4791",
      "4720",
      "4519",
      "4671",
      "4568",
      "4891",
      "4569",
      "4838",
      "4843",
      "4710",
      "4819",
      "4777",
      "4814",
      "4761",
      "4507",
      "4700",
      "4796",
      "4558",
      "4669",
      "4805",
      "4683",
      "4552",
      "4629",
      "4721",
      "4551",
      "4021",
      "4845",
      "4570",
      "4897",
      "4624",
      "4835",
      "4887",
      "4647",
      "4670",
      "4645",
      "4865",
      "4734",
      "4660",
      "4423",
      "4839",
      "4517",
      "4417",
      "4596",
      "4833",
      "4730",
      "4831",
      "4563",
      "4635",
      "4753",
      "4772",
      "4740",
      "4605",
      "4812",
      "4527",
      "4866",
      "4560",
      "4646",
      "4634",
      "4655",
      "4803",
      "4765",
      "4693",
      "4626",
      "4587",
      "4769",
      "4566",
      "4673",
      "4617",
      "4708",
      "4557",
      "4663",
      "4820",
      "4572",
      "4019",
      "4810",
      "4802",
      "4711",
      "4829",
      "4542",
      "4597",
      "4775",
      "4415",
      "4774",
      "4792",
      "4816",
      "4666",
      "4518",
      "4416",
      "4554",
      "4607",
      "4890",
      "4847",
      "4844",
      "4895",
      "4790",
      "4787",
      "4848",
      "4561",
      "4651",
      "4732",
      "4798",
      "4533",
      "4584",
      "4750",
      "4656",
      "4580",
      "4784",
      "4471",
      "4725",
      "4585",
      "4858",
      "4667",
      "4712",
      "4705",
      "4821",
      "4520",
      "4659",
      "4782",
      "4538",
      "4608",
      "4606",
      "4809",
      "4602",
      "4747",
      "4863",
      "4478",
      "4522",
      "4799",
      "4020",
      "4594",
      "4731",
      "4662",
      "4783",
      "4571",
      "4846",
      "4849",
      "4658",
      "4573",
      "4827",
      "4475",
      "4512",
      "4506",
      "4709",
      "4862",
      "4630",
      "4472",
      "4619",
      "4836",
      "4779",
      "4567",
      "4615",
      "4678",
      "4886",
      "4680",
      "4574",
      "4586",
      "4789",
      "4800",
      "4817",
      "4604",
      "4672",
      "4640",
      "4589",
      "4603",
      "4832",
      "4687",
      "4752",
      "4474",
      "4781",
      "4771",
      "4625",
      "4764",
      "4677",
      "4871",
      "4623",
      "4419",
      "4427",
      "4743",
      "4516",
      "4811",
      "4869",
      "4627",
      "4841",
      "4426",
      "4644",
      "4794",
      "4742",
      "4588",
      "4622",
      "4428",
      "4706",
      "4795",
      "4852",
      "4688",
      "4689",
      "4870",
      "4889",
      "4633",
      "4638",
      "4867",
      "4685",
      "4723",
      "4899",
      "4682",
      "4786",
      "4639",
      "4581",
      "4785",
      "4724",
      "4661",
      "4548",
      "4749",
      "4806",
      "4738",
      "4883",
      "4674",
      "4842",
      "4861",
      "4733",
      "4613",
      "4420",
      "4691",
      "4562",
      "4595",
      "4465",
      "4767",
      "4526",
      "4686",
      "4591",
      "4681",
      "4834",
      "4601",
      "4768",
      "4788",
      "4882",
      "4894",
      "4859",
      "4830",
      "4695",
      "4778",
      "4592",
      "4412",
      "4539",
      "4616",
      "4610",
      "4877",
      "4577",
      "4729",
      "4826",
      "4697",
      "4754",
      "4575",
      "4654",
      "4878",
      "4825",
      "4022",
      "4583",
      "4818",
      "4715",
      "4611",
      "4637",
      "4748",
      "4744",
      "4632",
      "4479",
      "4653",
      "4776",
      "4745",
      "4770",
      "4726",
      "4698",
      "4509",
      "4536",
      "4757",
      "4872",
      "4424",
      "4455",
      "4462",
      "4521",
      "4621",
      "4874",
      "4549",
      "4868",
      "4808",
      "4759",
      "4722",
      "4461",
      "4755",
      "4736",
      "4422",
      "4793",
      "4402",
      "4668",
      "4529",
      "4881",
      "4600",
      "4612",
      "4675",
      "4851",
      "4523",
      "4850",
      "4813",
      "4719",
      "4508",
      "4702",
      "4780",
      "4880",
      "4856",
      "4546",
      "4853",
      "4582",
      "4718",
      "4565",
      "4609",
      "4694",
      "4828",
      "4762",
      "4525",
      "4876",
      "4410",
      "4716",
      "4418",
      "4758",
      "4860",
      "4822",
      "4797",
      "4664",
      "4714",
      "4564",
      "4756",
      "4766",
      "4532",
      "4631",
      "4650",
      "4692",
      "4893",
      "4896",
      "4713",
      "4599",
      "4855",
    ];

    var mainCities = [
      "Sydney",
      "Adelaide",
      "Melbourne",
      "Mildura West",
      "Mildura",
      "Hattah",
      "Queensland",
      "Maroochydore",
    ];
    const selectedPostCodes = [
      ...mainCitiesWithCode["Sydney"],
      ...mainCitiesWithCode["Adelaide"],
      ...mainCitiesWithCode["Melbourne"],
      ...mainCitiesWithCode["Mildura West"],
      ...mainCitiesWithCode["Mildura"],
      ...mainCitiesWithCode["Hattah"],
      ...mainCitiesWithCode["Queensland"],
      ...mainCitiesWithCode["Maroochydore"],
    ];
    if (selectedPostCodes.includes(address) === true) {
      address = "Postcode " + address + " Australia";
    }
    var formatted_address = this.sentenceCase(address);
    if (mainCities.includes(formatted_address) !== false) {
      address = formatted_address + " " + mainCitiesWithCode[formatted_address];
    }
    var geocoder = new google.maps.Geocoder();
    var parent = this;
    geocoder.geocode({ address: address }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        parent.removeMessage("addressNotFound");
        parent.mapFocus = results[0].geometry.location;
        parent.results.setLocation(parent.mapFocus.lat(), parent.mapFocus.lng());
        parent.results.update();
        parent.gmap.show();
      } else {
        parent.results.setLocation(null, null);
        parent.addMessage("addressNotFound", address + " not found.", true);
      }
    });
  }
  updateMap() {
    this.gmap.searchLocationsNear(this.mapFocus, this.results.getAllOutlets());
  }
}

class ClickAndCollectCart extends ClickAndCollect {
  constructor(settings) {
    super(settings);
    this.mode = null;
    this.modeButtons = {};
    this.outletContactFields = {};
    this.addModeButtons(["home", "store"]);
    this.addOutletContactFields(["address1", "address2", "address3", "suburb", "state", "postcode", "phone", "email"]);
    this.addOutletNameField();
    this.addOutletNumberField();
    this.addResults();
    this.addCartUpdateListener();
    this.setMode("home");
    this.updateCollectionAbility();
    if (!this.settings.enableMap) {
      this.results.update();
    }
  }
  addModeButtons(values) {
    for (var value of values) {
      var button = new ModeButton(this, value);
      this.modeButtons[value] = button;
      this.element.appendChild(button.getElement());
      this.element.appendChild(button.getLabel());
    }
    var modeInput = document.createElement("input");
    modeInput.id = `cnc-mode-input`;
    modeInput.type = "hidden";
    if (window.location.href.indexOf("cart") > -1) {
      modeInput.name = "attributes[cnc-fulfilment-method]";
    } else {
      modeInput.name = "checkout[attributes][cnc-fulfilment-method]";
    }
    modeInput.value = "home";
    this.element.appendChild(modeInput);
    this.modeInput = modeInput;
  }
  addOutletContactFields(fieldNames) {
    for (var fieldName of fieldNames) {
      var field = new OutletContactField(fieldName);
      this.outletContactFields[fieldName] = field;
      this.element.appendChild(field.getElement());
    }
  }
  addOutletNumberField() {
    if (window.location.href.indexOf("cart") > -1) {
      var field = new OutletContactField("number", "cnc-outlet", "attributes[cnc-outlet]");
    } else {
      var field = new OutletContactField("number", "cnc-outlet", "checkout[attributes][cnc-outlet]");
    }
    this.outletNumberField = field;
    this.element.appendChild(field.getElement());
  }
  addOutletNameField() {
    if (window.location.href.indexOf("cart") > -1) {
      var field = new OutletContactField("name", "cnc-store-name", "attributes[cnc-store-name]");
    } else {
      var field = new OutletContactField("name", "cnc-store-name", "checkout[attributes][cnc-store-name]");
    }
    this.outletNameField = field;
    this.element.appendChild(field.getElement());
  }
  addResults() {
    this.results = new CartResults(this, this.settings.apiPrefix, this.settings.subdomain);
    this.resultsContainer.appendChild(this.results.getElement());
  }
  getMode() {
    return this.mode;
  }
  setMode(mode) {
    if (mode === this.mode) {
      return;
    }
    this.clearErrors();
    this.mode = mode;
    this.modeInput.value = mode;
    for (let [key, modeButton] of Object.entries(this.modeButtons)) {
      if (modeButton.getValue() === mode) {
        modeButton.select();
      }
      modeButton.updateDisplay();
    }
    if (this.mode === "home") {
      if (this.mapContainer) {
        this.mapContainer.style.display = "none";
      }
      this.results.hide();
      this.results.selectNone();
      for (let [key, contactField] of Object.entries(this.outletContactFields)) {
        contactField.clear();
      }
      this.outletNameField.clear();
      this.addMessage("home", "You will be able to select a home delivery method in the checkout.", false);
    } else if (this.mode === "store") {
      if (this.mapContainer) {
        this.mapContainer.style.display = "";
      }
      this.results.show();
      this.removeMessage("home");
      this.results.selectFirst();
      this.updateContactFields();
    }
    this.updateCheckoutButton();
  }
  updateCollectionAbility() {
    if (this.results.doOutletsExist() || this.settings.enableMap) {
      this.modeButtons["store"].show();
      this.removeMessage("noLocations");
    } else {
      this.setMode("home");
      this.modeButtons["store"].hide();
      this.addMessage("noLocations", "No locations available for store pickup.", true);
    }
  }
  updateContactFields() {
    var selectedOutlet = this.results.getSelectedOutlet();
    if (selectedOutlet) {
      for (let [key, contactField] of Object.entries(this.outletContactFields)) {
        contactField.setValue(selectedOutlet.getContact()[key]);
      }
      this.outletNameField.setValue(selectedOutlet.getName());
      this.outletNumberField.setValue(selectedOutlet.getExternalId());
    }
  }

  noWarehouse() {
    if (this.results.isLoaded()) {
      const outlet5 = document.getElementById("cnc-outlet-5");
      const outlet6 = document.getElementById("cnc-outlet-6");
      const outlet7 = document.getElementById("cnc-outlet-7");
      const errorMessage = document.getElementById("warehouse-error-message");
      // if ($(".isFurniture")[0]) {
      //   if (outlet5 == null && outlet6 == null && outlet7 == null) {
      //     errorMessage.innerHTML =
      //       " We're Sorry! This product is currently not available for collection, Please select Home Delivery instead.";
      //   } else {
      //     errorMessage.innerHTML = "";
      //   }
      // }
    }
  }

  updateCheckoutButton() {
    var checkoutButton =
      document.querySelector('button[name="checkout"]') ||
      document.querySelector('input[name="checkout"]') ||
      document.querySelector('button[id="continue_button"]') ||
      document.querySelector('input[id="continue_button"]');
    if (checkoutButton) {
      this.checkoutButton = checkoutButton;
      if (this.mode === "store" && !this.results.areOutletsAvailable()) {
        // checkoutButton.disabled = true;
        if (this.results.isLoaded()) {
          if (this.settings.enableMap && this.results.count() < 1) {
            this.removeMessage("pleaseUpdateCart");
            this.addMessage(
              "pleaseSearchAgain",
              "We're Sorry! This product is currently not available for collection, Please select Home Delivery instead.",
              true
            );
          } else {
            this.removeMessage("pleaseSearchAgain");
            this.addMessage(
              "pleaseUpdateCart",
              "We're Sorry! This product is currently not available for collection, Please select Home Delivery instead.",
              true
            );
          }
        }
      } else {
        checkoutButton.disabled = false;
        this.removeMessage("pleaseUpdateCart");
        this.removeMessage("pleaseSearchAgain");
      }
    }
  }
  addCartUpdateListener() {
    var parent = this;
    var cartTable = document.getElementById("CartProducts");
    if (cartTable) {
      cartTable.addEventListener("DOMSubtreeModified", (event) => {
        if (parent.results.isLoaded()) {
          parent.results.update();
        }
      });
    }
  }
}

class ClickAndCollectProduct extends ClickAndCollect {
  constructor(settings, initialVariantId) {
    super(settings);
    this.initialVariantId = initialVariantId;
    this.addCheckStockButton();
    this.addResults();
    this.addVariantEventListener();
    if (this.mapContainer) {
      this.mapContainer.style.display = "none";
    }
  }
  addCheckStockButton() {
    var checkStockButton = new CheckStockButton(this);
    this.element.appendChild(checkStockButton.getElement());
  }
  addResults() {
    var results = new ProductResults(this, this.settings.apiPrefix, this.settings.subdomain, this.initialVariantId);
    this.results = results;
    this.resultsContainer.appendChild(this.results.getElement());
  }
  addVariantEventListener() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      form.addEventListener("click", (event) => {
        if (this.results.isLoaded()) {
          this.results.unload();
          this.clearErrors();
          if (this.settings.enableMap) {
            this.mapContainer.style.display = "none";
            this.gmap.hide();
          }
        }
      });
    }
  }
  reveal() {
    if (this.settings.enableMap) {
      this.mapContainer.style.display = "";
    } else {
      this.results.fetch();
    }
  }
  resultsLoaded() {
    if (this.settings.enableMap && this.results.count() < 1) {
      this.addMessage(
        "pleaseSearchAgain",
        "We're Sorry! This product is currently not available for collection in this area, Please select Home Delivery instead.",
        true
      );
    } else {
      this.removeMessage("pleaseSearchAgain");
    }
  }
}

class Renderable {
  getElement() {
    return this.element;
  }
  show() {
    this.element.style.display = "";
    if (this.label) {
      this.label.style.display = "";
    }
  }
  hide() {
    this.element.style.display = "none";
    if (this.label) {
      this.label.style.display = "none";
    }
  }
}

class AddressSearch extends Renderable {
  constructor(cnc) {
    super();
    this.cnc = cnc;
    this.createElement();
  }
  createElement() {
    this.element = document.createElement("div");
    this.element.classList.add("cnc-address-search");
    this.element.id = "cnc-address-search";
    this.label = document.createElement("p");
    this.label.innerHTML =
      "You will be able to select a store pickup method in the checkout. Contact 1300 296 505 for more details.";
    this.element.appendChild(this.label);
    this.input = document.createElement("input");
    this.input.type = "text";
    this.input.classList.add("cnc-address-search-input");
    this.input.placeholder = "Enter Postcode To Check Our Inventory";
    this.element.appendChild(this.input);
    this.button = document.createElement("button");
    this.button.type = "button";
    this.button.classList.add("cnc-address-search-button");
    this.button.innerHTML = '<i class="fas fa-search"></i><span class="cnc-address-search-label">Search</span>';
    this.element.appendChild(this.button);
    this.button.addEventListener("click", (event) => {
      this.cnc.searchAddress(this.input.value);
    });
    var parent = this;
    this.input.addEventListener("keyup", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        parent.button.click();
        return false;
      }
    });
    this.input.addEventListener("keydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        return false;
      }
    });
  }
}

class GMap extends Renderable {
  constructor(cnc) {
    super();
    this.cnc = cnc;
    this.gmap;
    this.markers = [];
    this.infoWindow;
    this.locationSelect;
    this.mapInitialised = false;
    this.createElement();
  }
  createElement() {
    this.element = document.createElement("div");
    this.element.id = "cnc-map";
    this.hide();
  }
  initMap() {
    var sydney = { lat: -33.863276, lng: 151.107977 };
    this.gmap = new google.maps.Map(this.element, {
      center: sydney,
      zoom: 11,
      zoomControl: true,
      mapTypeId: "roadmap",
    });
    this.infoWindow = new google.maps.InfoWindow();
    this.mapInitialised = true;
  }
  clearLocations() {
    this.infoWindow.close();
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers.length = 0;
  }
  searchLocationsNear(center, outlets) {
    this.clearLocations();
    var bounds = new google.maps.LatLngBounds();
    for (let [name, outlet] of Object.entries(outlets)) {
      var bounds = new google.maps.LatLngBounds();
      var address = outlet.getAddressHtml();
      var distance = 0;
      var latlng = new google.maps.LatLng(
        parseFloat(outlet.getContact().latitude),
        parseFloat(outlet.getContact().longitude)
      );
      this.createMarker(latlng, name, address, outlet.data.distance);
      bounds.extend(latlng);
    }
    if (outlets.length >= 1) {
      this.gmap.fitBounds(bounds);
      var zoom = this.gmap.getZoom();
      this.gmap.setZoom(zoom > 10 ? 10 : zoom);
    } else {
      this.gmap.setCenter(center);
    }
  }
  createMarker(latlng, name, address, distance) {
    var html = `<b>${name}</b><br>`;
    if (distance) {
      html += distance + "km<br>";
    }
    html += address;
    var marker = new google.maps.Marker({
      map: this.gmap,
      position: latlng,
    });
    var parent = this;
    google.maps.event.addListener(marker, "click", function () {
      parent.infoWindow.setContent(html);
      parent.infoWindow.open(parent.gmap, marker);
    });
    this.markers.push(marker);
  }
}

class ModeButton extends Renderable {
  constructor(cnc, value) {
    super();
    this.cnc = cnc;
    this.value = value;
    this.createElement();
    this.createLabel();
    this.element.addEventListener("change", (event) => {
      this.cnc.setMode(this.element.value);
      this.hideCNCShipping();
    });
    this.updateDisplay();
  }
  select() {
    if (!this.element.checked) {
      this.element.checked = true;
    }
  }
  updateDisplay() {
    if (this.element.checked) {
      this.label.classList.add("btn--secondary");
    } else {
      this.label.classList.remove("btn--secondary");
    }
  }
  createElement() {
    this.element = document.createElement("input");
    this.element.id = `cnc-${this.value}-radio`;
    this.element.type = "radio";
    this.element.value = this.value;
    this.element.name = "cnc-mode-radio";
  }
  createLabel() {
    this.label = document.createElement("label");
    this.label.setAttribute("for", `cnc-${this.value}-radio`);
    this.label.classList.add("btn", "cnc-opt");
    if (this.value === "home") {
      this.label.innerHTML = '<i class="fas fa-globe-americas"></i><br>Home Delivery';
      this.hideCNCShipping();
    } else if (this.value === "store") {
      this.label.style.display = "none";
      if ($(".isFurniture")[0]) {
        this.label.innerHTML = '<i class="fas fa-store"></i><br><span class="store-text">Warehouse Pickup</span>';
      } else {
        this.label.innerHTML = '<i class="fas fa-store"></i><br><span class="store-text">Store Pickup</span>';
      }
    }
  }
  getLabel() {
    return this.label;
  }
  getValue() {
    return this.element.value;
  }

  hideCNCShipping() {
    if (this.value === "home") {
      $("input[id^=checkout_shipping_rate_id_delivery_rates_by_zip_code-click-and-collect]")
        .closest(".content-box__row")
        .hide();
      $("#continue_button").prop("disabled", false).removeClass("btn--disabled");
      if ($(".isFurniture")[0]) {
        $("input[id^=checkout_shipping_rate_id_delivery_rates_by_zip_code-furniture-delivery]").trigger("click");
      } else {
        $("input[id^=checkout_shipping_rate_id_delivery_rates_by_zip_code-accessories-delivery").trigger("click");
      }
    } else if (this.value === "store") {
      $("input[id^=checkout_shipping_rate_id_delivery_rates_by_zip_code-click-and-collect]")
        .closest(".content-box__row")
        .show()
        .trigger("click");
      $("input[id^=checkout_shipping_rate_id_delivery_rates_by_zip_code-click-and-collect]").trigger("click");
      $("#continue_button").prop("disabled", true).addClass("btn--disabled");
    }

    $(document).on("click", ".cnc-outlet", function () {
      $("#continue_button").prop("disabled", false).removeClass("btn--disabled");
    });
  }
}

class CheckStockButton extends Renderable {
  constructor(cncProduct) {
    super();
    this.cncProduct = cncProduct;
    this.createElement();
    this.element.addEventListener("click", (event) => {
      var addToCartButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
      if (addToCartButton && addToCartButton.disabled) {
        this.cncProduct.addMessage("productUnavailable", "Product variant is unavailable.", true);
      } else {
        this.cncProduct.removeMessage("productUnavailable");
        this.cncProduct.reveal();
      }
    });
  }
  createElement() {
    this.element = document.createElement("button");
    this.element.classList.add("postcode-btn");
    this.element.innerHTML =
      '<i class="fas fa-store"></i><br><span>Enter your postcode for delivery pricing and availability</span>';
    this.element.classList.add("btn");
  }
}

class Outlet extends Renderable {
  constructor(cnc, data, cartItems) {
    super();
    this.cnc = cnc;
    this.data = data;
    this.createAvailabilityTable(cartItems);
    this.createElement();
    this.createLabel();
    this.element.addEventListener("change", (event) => {
      cnc.updateContactFields();
    });
  }
  getAvailability() {
    return this.availabilityTable && this.availabilityTable.isOutletAvailable();
  }
  getAvailabilityTable() {
    return this.availabilityTable;
  }
  createAvailabilityTable(cartItems) {
    this.availabilityTable = new AvailabilityTable(
      cartItems,
      this.data.stock,
      true,
      this.cnc.settings.showQuantity,
      this.data.name
    );
  }
  isSelected() {
    return this.element.checked;
  }
  select() {
    this.element.checked = true;
  }
  deselect() {
    this.element.checked = false;
  }
  getContact() {
    return this.data.contact;
  }
  getName() {
    return this.data.name;
  }
  getExternalId() {
    return this.data.external_id;
  }
  createElement() {
    this.element = document.createElement("input");
    // Note: this is causing issues with the label
    // with this .id enabled, it will cause the second label missing
    // If we need this somehow, we can "reload/refetch" the Outlet again after the first fetch
    //this.element.id = `cnc-outlet-${this.data.external_id}`;
    this.element.type = "radio";
    this.element.name = "cnc-outlet-element";
    this.element.value = this.data.external_id;
    this.element.disabled = !this.getAvailability();
    this.element.classList.add("cnc-outlet");
  }
  createLabel() {
    this.label = document.createElement("label");
    this.label.setAttribute("for", `cnc-outlet-${this.data.external_id}`);
    this.label.classList.add("cnc-outlet-label");
    this.label.classList.add(`label-cnc-outlet-${this.data.external_id}`);
    var storeDetails = document.createElement("div");
    storeDetails.classList.add("cnc-store-details");
    storeDetails.insertAdjacentHTML("beforeend", `<strong>${this.data.name}</strong><br>`);
    if (this.data.distance) {
      storeDetails.insertAdjacentHTML("beforeend", this.data.distance + "km<br>");
    }
    storeDetails.insertAdjacentHTML("beforeend", this.getAddressHtml());
    this.label.appendChild(storeDetails);
    this.label.appendChild(this.getAvailabilityTable().getElement());
  }
  getAddressHtml() {
    var address = document.createElement("span");
    address.id = `cnc-outlet-${this.data.external_id}-address`;
    var innerHtml = "";
    if (this.data.contact.address1) {
      innerHtml += this.data.contact.address1 + "<br>";
    }
    if (this.data.contact.address2) {
      innerHtml += this.data.contact.address2 + "<br>";
    }
    if (this.data.contact.address3) {
      innerHtml += this.data.contact.address3 + "<br>";
    }
    if (this.data.contact.suburb) {
      innerHtml += this.data.contact.suburb + " ";
    }
    if (this.data.contact.state) {
      innerHtml += this.data.contact.state + " ";
    }
    if (this.data.contact.postcode) {
      innerHtml += this.data.contact.postcode;
    }
    innerHtml += "<br>";
    if (this.data.contact.phone) {
      innerHtml += `Phone: <a href="tel:${this.data.contact.phone}">${this.data.contact.phone}</a><br>`;
    }
    if (this.data.contact.email) {
      // innerHtml += `Email: <a href="mailto:${this.data.contact.email}">${this.data.contact.email}</a>`;
    }
    return innerHtml;
  }
  getLabel() {
    return this.label;
  }
}

class ProductOutlet extends Outlet {
  constructor(cnc, data, cartItems) {
    super(cnc, data, cartItems);
  }
  createAvailabilityTable(cartItems) {
    this.availabilityTable = new AvailabilityTable(
      cartItems,
      this.data.stock,
      false,
      this.cnc.settings.showQuantity,
      this.data.name
    );
  }
  createElement() {
    this.element = document.createElement("div");
    this.element.classList.add("cnc-outlet");
  }
  createLabel() {
    this.label = document.createElement("div");
    this.label.classList.add("cnc-outlet-label");
    this.label.classList.add("cnc-product-outlet-label");
    this.label.classList.add(`cnc-outlet-pdp-${this.data.external_id}`);
    var storeDetails = document.createElement("div");
    storeDetails.classList.add("cnc-store-details");
    storeDetails.insertAdjacentHTML("beforeend", `<strong>${this.data.name}</strong><br>`);
    storeDetails.insertAdjacentHTML("beforeend", this.getAddressHtml());
    this.label.appendChild(storeDetails);
    this.label.appendChild(this.getAvailabilityTable().getElement());
  }
}

class AvailabilityTable extends Renderable {
  constructor(cartItems, stockLevels, showTable, showQuantity, name) {
    super();
    this.products = [];
    this.showTable = showTable;
    this.showQuantity = showQuantity;
    this.name = name;
    this.updateProducts(cartItems, stockLevels);
    this.createElement();
  }
  updateProducts(cartItems, stockLevels) {
    if (cartItems && cartItems.length) {
      for (let cartItem of cartItems) {
        var product = Object.assign({}, cartItem);
        product.outletStock = stockLevels[cartItem.variant_id];
        this.products.push(product);
      }
    } else {
      for (let [variantId, stockLevel] of Object.entries(stockLevels)) {
        var product = {
          variant_id: variantId,
          outletStock: stockLevel,
          quantity: 1,
        };
        this.products.push(product);
      }
    }
  }
  isOutletAvailable() {
    for (let product of this.products) {
      if (!this.isProductAvailable(product)) {
        return false;
      }
    }
    return true;
  }
  isProductAvailable(product) {
    return product.outletStock >= product.quantity;
  }
  createElement() {
    if (this.showTable) {
      this.createTableElement();
    } else {
      this.createTextElement();
    }
  }
  createTableElement() {
    this.element = document.createElement("table");
    this.element.classList.add("cnc-availability-table");

    let isCartPage = window.location.pathname.includes("/cart");

    if (this.isOutletAvailable()) {
      var headingHtml = `<tr><th colspan="6" class="cnc-heading-available">All items available</th></tr>`;
    } else {
      var headingHtml = `<tr><th colspan="6" class="cnc-heading-unavailable">Some items are not available</th></tr>`;
    }
    var head = document.createElement("thead");
    head.insertAdjacentHTML("beforeend", headingHtml);
    this.element.appendChild(head);

    var body = document.createElement("tbody");
    for (let product of this.products) {
      let availabilityElement = null;
      if (isCartPage) {
        availabilityElement = document.createElement("p");
        availabilityElement.classList.add("cnc-heading-availability");

        availabilityElement.style.cssText = `
          border-radius: 50px;
          padding: 2px 20px;
          font-size: 13px;
          font-weight: 400;
          white-space: nowrap;
          text-transform: none;
        `;

        if (this.isProductAvailable(product)) {
          if (this.showQuantity && this.products.length === 1) {
            availabilityElement.innerHTML = `${product.outletStock} available`;
          } else {
            availabilityElement.innerHTML = "On display";
            if (this.name && (this.name.includes("Warehouse") || this.name.includes("warehouse")))
              availabilityElement.innerHTML = "In stock";
          }
          availabilityElement.classList.add("cnc-heading-available");
        } else {
          availabilityElement.innerHTML = "Out of stock";
          availabilityElement.classList.add("cnc-heading-unavailable");
        }
      }

      if (this.isProductAvailable(product)) {
        var productTitle = product.title;
      } else if (product.outletStock > 0) {
        var productTitle = `<span class="strike">${product.title}</span> <span class="cnc-negative-text">(Insufficient stock)</span>`;
      } else {
        var productTitle = `<span class="strike">${product.title}</span> <span class="cnc-negative-text">(Out of stock)</span>`;
      }

      if (this.showQuantity) {
        var productAvailable = this.isProductAvailable(product)
          ? `<span class="cnc-positive-text"><strong>${product.outletStock}</strong></span>`
          : `<span class="cnc-negative-text"><strong>${product.outletStock}</strong></span>`;
      } else {
        var productAvailable = this.isProductAvailable(product)
          ? '<i class="fas fa-check-circle cnc-positive-text"></i>'
          : '<i class="fas fa-times-circle cnc-negative-text"></i>';
      }

      let availabilityHtml = isCartPage ? `<td>${availabilityElement.outerHTML}</td>` : "";

      body.insertAdjacentHTML(
        "beforeend",
        `<tr><td>${productTitle}</td><td>${product.quantity}</td>${availabilityHtml}<td>${productAvailable}</td></tr>`
      );
    }
    this.element.appendChild(body);
  }
  createTextElement() {
    this.element = document.createElement("p");
    this.element.classList.add("cnc-heading-availability");
    if (this.isOutletAvailable()) {
      if (this.showQuantity && this.products.length === 1) {
        this.element.innerHTML = `${this.products[0].outletStock} available`;
      } else {
        this.element.innerHTML = "On display";
        if (this.name && (this.name.includes("Warehouse") || this.name.includes("warehouse"))) {
          this.element.innerHTML = "In stock";
        }
      }
      this.element.classList.add("cnc-heading-available");
    } else {
      if (this.name && !(this.name.includes("Warehouse") || this.name.includes("warehouse"))) {
        this.element.innerHTML = "Not on display";
      } else {
        this.element.innerHTML = "Out of stock";
      }
      this.element.classList.add("cnc-heading-unavailable");
    }
  }
}

class OutletContactField extends Renderable {
  constructor(name, id, elementName) {
    super();
    this.name = name;
    this.createElement(id, elementName);
  }
  createElement(id, elementName) {
    this.element = document.createElement("input");
    this.element.type = "hidden";
    this.element.classList.add("cnc-contact");
    this.element.id = id || `cnc-contact-${this.name}`;
    this.element.name = elementName || `attributes[cnc-store-${this.name}]`;
    this.element.value = "";
  }
  getElement() {
    return this.element;
  }
  clear() {
    this.element.value = "";
  }
  setValue(value) {
    this.element.value = value;
  }
}

class Message extends Renderable {
  constructor(value, isError) {
    super();
    this.createElement();
    this.setValue(value);
    this.setIsError(isError);
  }
  createElement() {
    this.element = document.createElement("div");
    this.element.id = "cnc-message";
    this.paragraph = document.createElement("p");
    this.element.appendChild(this.paragraph);
  }
  getValue() {
    return this.value;
  }
  setValue(value) {
    this.value = value;
    this.paragraph.innerHTML = value;
  }
  clear() {
    this.setValue("");
  }
  setIsError(bool) {
    this.isError = bool;
    if (this.isError) {
      this.element.classList.add("cnc-negative-text");
    } else {
      this.element.classList.remove("cnc-negative-text");
    }
  }
}

class Results extends Renderable {
  constructor(cnc, apiPrefix, subdomain) {
    super();
    this.cnc = cnc;
    this.apiPrefix = apiPrefix;
    this.subdomain = subdomain;
    this.outlets = {};
    this.loaded = false;
    this.lastUpdate = 0;
  }
  update() {}
  fetch() {}
  createElement() {
    this.element = document.createElement("div");
    this.element.id = "cnc-results";
    this.element.style.display = "none";
  }
  createList() {
    this.list = document.createElement("ul");
    this.list.id = "cnc-outlets";
    this.list.classList.add("cart-attribute__field");
    this.element.appendChild(this.list);
  }
  setLocation(latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
  getAllOutlets() {
    return this.outlets;
  }
  count() {
    return Object.keys(this.outlets).length;
  }
  unload() {
    this.outlets = [];
    while (this.list.firstChild) {
      this.list.removeChild(this.list.firstChild);
    }
  }
  renderOutlet(outlet) {
    var listItem = document.createElement("li");
    listItem.appendChild(outlet.getElement());
    listItem.appendChild(outlet.getLabel());
    this.list.appendChild(listItem);
  }
  isLoaded() {
    return this.loaded;
  }
  doOutletsExist() {
    return Object.keys(this.outlets).length > 0;
  }
  areOutletsAvailable() {
    for (let [key, outlet] of Object.entries(this.outlets)) {
      if (outlet.getAvailability()) {
        return true;
      }
    }
  }
}

class CartResults extends Results {
  constructor(cnc, apiPrefix, subdomain) {
    super(cnc, apiPrefix, subdomain);
    this.createElement();
    this.createInfo();
    this.createList();
    this.variantIds = [];
    this.cartItems = {};
  }
  createInfo() {
    this.info = document.createElement("p");
    this.info.id = "cnc-info";
    this.element.appendChild(this.info);
  }
  setInfo(value) {
    this.info.innerHTML = value;
  }
  selectNone() {
    for (let [key, outlet] of Object.entries(this.outlets)) {
      outlet.deselect();
      this.cnc.updateContactFields();
    }
  }
  selectFirst() {
    for (let [key, outlet] of Object.entries(this.outlets)) {
      if (outlet.getAvailability()) {
        outlet.select();
        this.cnc.updateContactFields();
        return;
      }
    }
  }
  getSelectedOutlet() {
    for (let [key, outlet] of Object.entries(this.outlets)) {
      if (outlet.isSelected()) {
        return outlet;
      }
    }
  }
  update() {
    if (Date.now() - this.lastUpdate < 1000) {
      return;
    }
    this.lastUpdate = Date.now();
    var parent = this;
    Shopify.getCart(function (cart) {
      var variantIds = [];
      cart.items.forEach(function (item) {
        variantIds.push(item.variant_id);
      });
      parent.cartItems = cart.items;
      parent.variantIds = variantIds;
      parent.fetch();
    });
  }
  fetch() {
    this.unload();
    var parent = this;
    var url = `https://${this.apiPrefix}/api/shopify_stores/${
      this.subdomain
    }/outlets?variant_ids=${this.variantIds.join()}`;
    for (let cartItem of this.cartItems) {
      url += `&qty-${cartItem.variant_id}=${cartItem.quantity}`;
    }
    if (this.latitude && this.longitude) {
      url += `&latitude=${this.latitude}&longitude=${this.longitude}`;
    }
    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        for (let outletJson of json.outlets) {
          var outlet = new Outlet(parent.cnc, outletJson, parent.cartItems);
          parent.outlets[outlet.getName()] = outlet;
          parent.renderOutlet(outlet);
        }
        if (json.outlets.length) {
          // parent.setInfo("Please choose a pickup location:");
          parent.setInfo("");
        } else {
          parent.setInfo("");
        }
        parent.loaded = true;
        parent.cnc.updateCollectionAbility();
        parent.cnc.updateCheckoutButton();
        if (parent.cnc.settings.enableMap) {
          parent.cnc.updateMap();
        }
        if (parent.cnc.getMode() === "store") {
          parent.selectFirst();
        }
      });
  }
}

class ProductResults extends Results {
  constructor(cnc, apiPrefix, subdomain, initialVariantId) {
    super(cnc, apiPrefix, subdomain);
    this.createElement();
    this.createList();
    this.initialVariantId = initialVariantId;
  }
  createElement() {
    this.element = document.createElement("div");
    this.element.id = "cnc-results";
  }
  update() {
    this.fetch();
  }
  fetch() {
    this.unload();
    var parent = this;
    var variantId = this.findGetParameter("variant");
    if (!variantId) {
      variantId = this.initialVariantId;
    }
    var url = `https://${this.apiPrefix}/api/shopify_stores/${this.subdomain}/outlets?variant_ids=${variantId}&qty-${variantId}=1`;
    if (this.latitude && this.longitude) {
      url += `&latitude=${this.latitude}&longitude=${this.longitude}`;
    }
    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        for (let outletJson of json.outlets) {
          var outlet = new ProductOutlet(parent.cnc, outletJson);
          parent.outlets[outlet.getName()] = outlet;
          parent.renderOutlet(outlet);
        }
        parent.loaded = true;
        if (parent.cnc.settings.enableMap) {
          parent.cnc.updateMap();
        }
        parent.cnc.resultsLoaded();
      });
  }
  getSelectedVariantIdFromHtml() {
    var select = document.getElementById("ProductSelect-product-template");
    if (select) {
      return select.options[select.selectedIndex].value;
    }
  }
  findGetParameter(parameterName) {
    var result = null,
      tmp = [];
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }
}
